import { useEffect } from 'react';
import { CardTab, CardTabNav } from 'components/card-tab';
import CURRENCY from 'utils/currency';
import useStats from 'state/stats/hooks/useStats';
import { getPercentChange } from 'utils/dashboard';
import { STATS } from 'state/stats/type';

interface IProps {
  currentDates: {
    from: string;
    to: string;
  };
  prevDates: {
    from: string;
    to: string;
  };
}

const Cards = ({ currentDates, prevDates }: IProps): JSX.Element => {
  const {
    stats: { activeSummaryTab, summary },
    toFetchSummaryCard,
    toSetSummaryTab,
  } = useStats();
  const totalSummary = Array.isArray(summary)
    ? summary?.filter(
        (summ) => summ.payment_type === STATS.IPaymentType.ALL
      )?.[0]
    : undefined;
  const aovValue = totalSummary?.current
    ? totalSummary?.current?.gross_volume / totalSummary?.current?.payments
    : 0;
  const aovPrevValue = totalSummary?.previous
    ? totalSummary?.previous?.gross_volume / totalSummary?.previous?.payments
    : 0;

  useEffect(() => {
    if (currentDates.from && currentDates.to) {
      toFetchSummaryCard({
        start_date: currentDates.from,
        end_date: currentDates.to,
        prev_start_date: prevDates.from,
        prev_end_date: prevDates.to,
        payment_type: Object.values(STATS.IPaymentType).join(','),
      });
    }
  }, [currentDates.from, currentDates.to]);

  const getSummaryCards = () => [
    {
      id: STATS.graphType.gross_amount,
      title: 'Gross Receipts',
      value: CURRENCY.getCompactNotation(totalSummary?.current?.gross_volume),
      percentChange: getPercentChange(
        totalSummary?.current?.gross_volume || 0,
        totalSummary?.previous?.gross_volume || 0
      ),
      tooltip: 'Total sales before deducting any fees, refunds or returns',
    },
    {
      id: STATS.graphType.payments,
      title: 'Total Transactions',
      value: totalSummary?.current?.payments || 0,
      percentChange: getPercentChange(
        totalSummary?.current?.payments || 0,
        totalSummary?.previous?.payments || 0
      ),
      tooltip:
        'Total payments successfully processed during a specific timeframe',
    },
    {
      id: STATS.graphType.aov,
      title: 'AOV',
      value: CURRENCY.getCompactNotation(aovValue || 0),
      percentChange: getPercentChange(aovValue, aovPrevValue),
      tooltip:
        'AOV (Average Order Value) measures the average dollar value per ticket when compared to the total dollar value of the tickets within a time period',
    },
  ];

  return (
    <CardTabNav className="mb-3">
      {totalSummary?.current &&
        totalSummary?.previous &&
        getSummaryCards().map((item) => {
          return (
            <CardTab
              id={item.id}
              title={item.title}
              tooltip={item.tooltip}
              value={item.value}
              onClick={() => toSetSummaryTab(item.id)}
              isActive={item?.id === activeSummaryTab}
              percentChange={item.percentChange}
            />
          );
        })}
    </CardTabNav>
  );
};
export default Cards;
